import { useTranslation } from 'next-i18next';

import { ButtonV3 } from 'components/ComponentV2';
import Link from 'components/Link';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './CompanyBanner.module.scss';

type CompanyBannerProps = {
  companyName: string;
  jobsCount: number;
};

export const CompanyBanner: React.FC<CompanyBannerProps> = ({ companyName, jobsCount }) => {
  const [t] = useTranslation('company');

  if (jobsCount === 0) return null;

  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <p className={styles.title}>{t('banner.title', { companyName, jobsCount })}</p>
        <Link href={PAGE_ROUTES.CANDIDATE_SIGN_IN} underlineOnHover={false}>
          <ButtonV3 size="small">{t('banner.cta')}</ButtonV3>
        </Link>
      </div>
    </section>
  );
};

CompanyBanner.displayName = 'CompanyBanner';
